@if (componentData$ | async; as carousel) {
  @if (banners$ | async; as banners) {
    <div class="container">
      @for (banner of banners; track banner.uid) {
        <aimo-simple-banner [banner]="banner"></aimo-simple-banner>
      }
    </div>
  } @else {
    <aimo-spinner></aimo-spinner>
  }
} @else {
  <aimo-spinner></aimo-spinner>
}

